import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Locales from './locale'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const numberFormats = {
  'en': {
    compact: {
      notation: 'compact',
      compactDisplay: 'short',
    }
  },
};

const locale = [
    ...(window.navigator.languages || []),
    window.navigator.language,
    window.navigator.browserLanguage,
    window.navigator.userLanguage,
    window.navigator.systemLanguage
].filter(Boolean)
  .map(language => language.substr(0, 2))
  .find(language => Object.keys(Locales).includes(language)) || 'en';

export default new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  numberFormats,
});